module.exports = __webpack_public_path__ + "static/media/tvshows-global-icon.27df441c.svg";